export function isCoderNotifySelectable(row) {
  const status = (row.accountStatus || '').trim()
  if (status === 'No Link') {
    return false
  }
  return status === 'Active' || !!row.coderEmail
}

export function isOriginalAuditorNotifySelectable(row) {
  const status = (row.accountStatus || '').trim()
  if (status === 'No Link') {
    return false
  }
  return status === 'Active' || !!row.originalAuditorEmail
}
